import { createAppRequest } from '@/services/request';

const request = createAppRequest();

/**
 * Taxonomy 类型定义
 */
export interface TaxonomyTagNode {
  uuid: string;
  identifier: string;
  name: string;
  description?: string;
  children?: TaxonomyTagNode[];
  parentUuid?: string;
  level: number;
}

export interface TaxonomyItem {
  uuid: string;
  identifier: string;
  name: string;
  type: 'hierarchical' | 'flat';
}

export interface TaxonomyTreeResponse {
  taxonomy: TaxonomyItem;
  tags: TaxonomyTagNode[];
}

/**
 * 获取分类法标签树
 * 使用 CRM 后端代理以解决可能的 CORS 问题
 * GET /bff/zy-crm/taxonomy/identifier/:identifier/tree
 */
export async function queryTaxonomyTreeByIdentifier(
  identifier: string,
): Promise<TaxonomyTreeResponse> {
  return request(`/bff/zy-crm/taxonomy/identifier/${identifier}/tree`, {
    method: 'GET',
  });
}
